
<template>
  <vs-sidebar click-not-close parent="#aset-app" :hidden-background="true" class="full-vs-sidebar aset-view-sidebar items-no-padding" v-model="isAkumulasiActive" position-right>
    <div class="px-0 sm:pb-6 h-full aset-area-loading">
      <div class="flex flex-wrap items-center justify-between md:px-8 px-6 py-5 d-theme-dark-bg aset-header">
        <div class="flex">
          <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="akumulasiAddClose" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
          <vs-button type="line" @click="akumulasiList()">List Akumulasi</vs-button>
        </div>
        <vs-button type="line" color="danger" @click="akumulasiTrash()">Trash</vs-button>
      </div>

      <component :is="scrollbarTag" class="aset-scroll-area md:p-8 p-6" :settings="settings" :key="$vs.rtl">
        <vx-card id="akumulasi-load" v-if="list_status">
          <div slot="no-body">
            <div class="flex justify-between items-center py-3 px-6 border border-solid d-theme-border-grey-light border-r-0 border-l-0 border-t-0">
              <h5>Total Akumulasi {{ totalAkumulasi | currency }}</h5>
              <h5>Dari Nilai {{ data.task_total | currency }}</h5>
              <vs-button color="primary" size="small" icon-pack="feather" icon="icon-plus" v-on:click="openJurnal()" v-if="data.status_lunas != 'Lunas Sudah'">Update</vs-button>
            </div>
          </div>
          <div>
            <transition-group name="list-enter-up" tag="ul" appear>
              <li
                class="cursor-pointer"
                v-for="(list, index) in listAkumulasi" :key="index"
                :style="[{transitionDelay: (index * 0.1) + 's'}]"
                @click="openView(list)">
                <div class="px-6 py-3 list-item-component-no-border">
                  <div class="flex mx-auto justify-between items-center">
                    <div>
                      <h6 class="progress-title">{{ list.tanggal }}</h6>
                      <div class="flex items-center">
                        <div class="h-3 w-3 rounded-full mr-2 bg-success"></div>
                        <p>{{ list.memo }}</p>
                      </div>
                    </div>
                    <h5 class="truncate">{{ list.task_total | currency}}</h5>
                  </div>
                </div>
              </li>
            </transition-group>
          </div>
        </vx-card>
        <vx-card id="akumulasi-load" v-else>
          <div slot="no-body">
            <div class="flex justify-between items-center py-3 px-6 border border-solid d-theme-border-grey-light border-r-0 border-l-0 border-t-0">
              <h5>Trash</h5>
            </div>
          </div>
          <div>
            <transition-group name="list-enter-up" tag="ul" appear>
              <li
                class="cursor-pointer"
                v-for="(list, index) in listAkumulasi" :key="index"
                :style="[{transitionDelay: (index * 0.1) + 's'}]"
                @click="openView(list)">
                <div class="px-4 py-3 list-item-component-no-border">
                  <div class="vx-row"  >
                    <div class="vx-col w-full sm:w-2/3 sm:items-center sm:flex-row flex-col">
                      <div class="progress-tags flex">
                        <span class="flex items-center rounded">
                          <div class="h-3 w-3 rounded-full mr-2 bg-danger"></div>{{ list.task_title}}
                        </span>
                      </div>
                      <h6 class="progress-title items-center sm:ml-5">{{ list.tanggal }}</h6>
                    </div>
                    <div class="vx-col w-full sm:w-1/3 items-center pt-2">
                      <h5 class="truncate">{{ list.task_total | currency}}</h5>
                    </div>
                  </div>
                </div>
              </li>
            </transition-group>
          </div>
        </vx-card>
      </component>
    </div>
    
    <jurnal :isJurnalActive="isJurnalActive" @closeJurnal="closeJurnal" :dataAset="data" :data="jurnalData" :status="list_status"></jurnal>
    
  </vs-sidebar>

</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
import Jurnal from './AsetJurnal.vue'

export default {
  props: {
    isAkumulasiActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    Jurnal
  },
  data () {
    return {
      isJurnalActive : false,
      jurnalData : {},
      list_status: true,

      settings: {
        maxScrollbarLength: 80,
        wheelSpeed: .80
      }
    }
  },
  watch: {
    isAkumulasiActive (val) {
      if (!val) { return } else {
        if (Object.entries(this.data).length != 0) {
          this.$vs.loading({
            background: this.backgroundLoading,
            color: this.colorLoading,
            container: '#akumulasi-load',
            type: 'sound',
            scale: 0.45
          })
          this.$store.dispatch('aset/fetchAkumulasi', this.data.id)
          setTimeout(() => {
            this.$vs.loading.close('#akumulasi-load > .con-vs-loading')
          }, 3000)
        }
      }
    }
  },
  computed: {
    isAkumulasiActiveLocal: {
      get () {
        return this.isAkumulasiActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeAkumulasi')
        }
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    }),
    listAkumulasi() {
      return this.$store.state.aset.akumulasis
    },
    totalAkumulasi() {
      return this.$store.state.aset.akumulasi_total
    }
  },
  mounted(){
  },
  beforeDestroy () {
  },
  methods: {
    akumulasiList() {
      if (Object.entries(this.data).length != 0) {
        this.list_status = true
        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: '#akumulasi-load',
          type: 'sound',
          scale: 0.45
        })
        this.$store.dispatch('aset/fetchAkumulasi', this.data.id)
        setTimeout(() => {
          this.$vs.loading.close('#akumulasi-load > .con-vs-loading')
        }, 3000)
      }
    },
    akumulasiTrash() {
      if (Object.entries(this.data).length != 0) {
        this.list_status = false
        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: '#akumulasi-load',
          type: 'sound',
          scale: 0.45
        })
        this.$store.dispatch('aset/fetchAkumulasiTrash', this.data.id)
        setTimeout(() => {
          this.$vs.loading.close('#akumulasi-load > .con-vs-loading')
        }, 3000)
      }
    },
    persen(val) {
      return parseInt(val)
    },
    openJurnal() {
      this.isJurnalActive = true
    },
    openView(data) {
      this.isJurnalActive = true
      this.jurnalData = data
    },
    closeJurnal() {
      this.isJurnalActive = false
    },
    akumulasiAddClose() {
      this.$emit('closeAkumulasi')
    }
  }
}
</script>
